import { Roles } from "../../constants/roles";
import { FormBase } from "../../util/form-base-form";

export class FloatingChatForm extends FormBase {
    public getFloatingButton(): HTMLElement | null {
        return this.queryElement(document.body, ".facebook-messenger-link--floating", HTMLElement);
    }

    public getLabel(button: HTMLElement): HTMLElement | null {
        return this.queryElement(button, ".facebook-messenger-link__label", HTMLElement);
    }

    public getProductPickers(): HTMLElement[] {
        return this.queryElements(
            document.body,
            `[data-role="${Roles.SEARCH_MENU_POST_PRODUCT_PICKER_CONTAINER}"]`,
            HTMLElement,
        );
    }
}
